// update state
const setActionDashboardlist = (payload) => {
    return {
        type: "ACTIONDASHBOARDLIST",
        payload
    }
}

export default setActionDashboardlist;


// WEBPACK FOOTER //
// ./src/actions/setActionDashboardlist.js